import { ILeftDrawer } from './interfaces';

export const initState: ILeftDrawer = {
  show: false,
  type: 'PROFILE',
};
